import type { OffsetOrigin } from "@skilitics/drag-drop";

export type LengthBehavior = "fit" | "fill" | "fixed";

export type Orientation = "horizontal" | "vertical";

export const alignments = [
  "alignTopLeft",
  "alignTopCenter",
  "alignTopRight",
  "alignLeft",
  "alignCenter",
  "alignRight",
  "alignBottomLeft",
  "alignBottomCenter",
  "alignBottomRight",
] as const;

export type Alignment = (typeof alignments)[number];

export type LayoutSettings = {
  verticalBehavior: LengthBehavior;
  horizontalBehavior: LengthBehavior;
  alignment?: Alignment;
  offsetOrigin?: OffsetOrigin;
};
